import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import '@/styles/global.css';
import { setupVitals } from './vitals';

// Build stamp (CI injeta VITE_BUILD_TAG=<branch>-<sha>): identifica no F12
// qual commit está deployado — espelho do org.opencontainers.image.revision.
const buildTag = import.meta.env.VITE_BUILD_TAG ?? 'dev';
document.documentElement.dataset.build = buildTag;
console.info(`chatia-web ${buildTag}`);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root nao encontrado em index.html');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Web Vitals → console em dev; em prod manda pra Sentry (configurar na Fase 1).
setupVitals();
